<template>
  <section class="scenes">
    <h2 class="section-title">核心场景展示</h2>
    <p class="subtitle">多维度满足不同玩家需求</p>

    <div class="scenes-grid">
      <div class="scene-item">
        <img src="../assets/Scenes/1.jpg" alt="竞技对决" class="scene-image" />
        <div class="scene-info">
          <div class="scene-icon">🏆</div>
          <h3>竞技对决</h3>
          <p>全国排行榜 + 实时对战画面</p>
        </div>
      </div>

      <div class="scene-item">
        <img src="../assets/Scenes/2.jpg" alt="社交互动" class="scene-image" />
        <div class="scene-info">
          <div class="scene-icon">👥</div>
          <h3>社交互动</h3>
          <p>追分自动记分 + 公会排行榜</p>
        </div>
      </div>

      <div class="scene-item">
        <img src="../assets/Scenes/3.jpg" alt="娱乐体验" class="scene-image" />
        <div class="scene-info">
          <div class="scene-icon">💡</div>
          <h3>娱乐体验</h3>
          <p>灯光秀 + 趣味音效</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Scenes'
}
</script>

<style scoped>
.scenes {
  padding: 4rem 5%;
  background-color: #fff;
}

.section-title {
  text-align: center;
  font-size: 2.5rem;
  margin-bottom: 1rem;
  color: #333;
}

.subtitle {
  text-align: center;
  color: #666;
  font-size: 1.1rem;
  margin-bottom: 4rem;
}

.scenes-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.scene-item {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  transition: transform 0.3s ease;
}

.scene-item:hover {
  transform: translateY(-5px);
}

.scene-image {
  width: 100%;
  height: 240px;
  object-fit: cover;
  display: block;
  border-radius: 12px;
}

.scene-info {
  text-align: center;
  margin-top: 1.5rem;
}

.scene-icon {
  font-size: 2rem;
  margin-bottom: 1rem;
  width: 64px;
  height: 64px;
  background: #f8f9fa;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1rem;
}

.scene-info h3 {
  font-size: 1.3rem;
  color: #333;
  margin-bottom: 0.5rem;
}

.scene-info p {
  color: #666;
  font-size: 1rem;
}

@media (max-width: 768px) {
  .scenes-grid {
    grid-template-columns: 1fr;
    gap: 3rem;
  }
}
</style>
